<template>
  <div>
      <div class="browserBox"  :class="$vuetify.theme.dark ? 'list-dark':''" >

        <template v-for="(item,index) in dataList">
           <v-col cols="12" md="3" lg="3" xl="3" sm="4"  v-if="browserKeys.includes(item.code)" :key="index"
                  :class="{'colStyle':true,'selected':selectedBrowser && selectedBrowser.code == item.code}" @click="handleSelect(item)">
            <div class="appSelect_box" >
              <div class="appImg">
                <v-img  :src="item.pic" alt="" />
              </div>
              <div class="pendApproval"  >
                <span class="pendApproval_text">{{item.name }}</span>
              </div>
            </div>
          </v-col>
        </template>
        </div>
            <v-row no-gutters>
              <v-col cols="12" class="mb-2 mt-2">
                <v-btn color="primary" @click="()=>$emit('success',selectedBrowser)" small>{{$t('btn.submit')}}</v-btn>
                <v-btn class="close_btn" outlined @click="()=>$emit('close')" small>{{$t('btn.close')}}</v-btn>
              </v-col>
            </v-row>
   </div>
</template>

<script>

  export default {
    name:'browserList',
    props:{

      browserKeys:{
        type:Array,
        default:()=> [


        ]
      }
    },
    data() {
      return {
        selectedBrowser:null,
        dataList:[
            {
              code:1,name:'Google chrome',
              pic: require('@/assets/img/browser/chrome.png')
            },
            {
              code:2,name:'IE浏览器',
              pic: require('@/assets/img/browser/ie.png')
            },
            {
              code:3,name:'Microsoft Edge',
              pic: require('@/assets/img/browser/edge.png')
            },
            {
              code:4,
              name: this.$t("adhibition.browserList.firefox"),
              pic: require('@/assets/img/browser/firefox.png')
            },
            {
              code:5,name:this.$t("adhibition.browserList.qq"),
              pic: require('@/assets/img/browser/browserQQ.png')
            },
            {
              code:6,name:this.$t("adhibition.browserList.sogou"),
              pic: require('@/assets/img/browser/sougou.png')},
            {
              code:7,name:this.$t("adhibition.browserList.safety360"),
              pic: require('@/assets/img/browser/browser360.png')
            },
            {
              code:8,name:this.$t("adhibition.browserList.safety360Speed"),
              pic: require('@/assets/img/browser/browser360Speed.png')
            },

          ]
      }

    },
    methods:{
      handleSelect(data) {
        this.selectedBrowser = data
      }

    }

  }



</script>


<style lang='scss' scoped>
  .browserBox{
    max-height: 400px;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .colStyle{
      padding: 8px;
      background: #F6F7F9;
      margin: 8px;
      border-radius: 10px;
      max-width: 138px;
      box-sizing: inherit;
      border:1px solid #F6F7F9;
      cursor: pointer;
    }

    .selected{
      border:1px solid #5063D0;
      color: #5063D0;
    }
    .colStyle:hover {
      border:1px solid #5063D0;
      color: #5063D0;

    }


    .appSelect_box{
      position: relative;
      .appImg{
        width:36px;
        height:36px;
        object-fit: cover;
      }
      .pendApproval{
        text-align: left;
        margin-top:5px;
        .pendApproval_text{

          font-size: 12px;

        }
      }
    }
  }

  .list-dark {
    .colStyle {
      background:  #3B355A !important;
    }
  }
  .v-list-item {
  .v-list-item__title {
    line-height: 1.5;
    max-width:300px;
    }
}
.subaccount-list-scorll {
  max-height: 400px;
  overflow-y: scroll;
}

  .close_btn{
    margin-left: 6px;
  }
</style>
